import {
  LoginResponseSchema,
  SeleccionarTenantResponseSchema,
  Verify2FAResponseSchema,
  type LoginRequest,
  type LoginResponse,
  type SeleccionarTenantRequest,
  type SeleccionarTenantResponse,
  type Verify2FARequest,
  type Verify2FAResponse,
} from '@alter/types';
import type { HttpClient } from './httpClient.js';
import type { TokenStorage } from './tokenStorage.js';

/**
 * Cliente de autenticación. Las 3 ramas de `/login` viven en `LoginResponse`
 * (discriminada por `tipo`). El caller decide qué hacer con cada rama y
 * usa `extractToken` para obtener el `TokenResponse` cuando hay uno.
 *
 * `logout()` es **local-only** — limpia `TokenStorage`. El backend no
 * documenta endpoint de logout (`02_CONTRATOS.md`).
 */
export class AuthClient {
  constructor(
    private readonly http: HttpClient,
    private readonly tokenStorage: TokenStorage,
  ) {}

  /** `POST /api/auth/login` — sin token (caller no autenticado todavía). */
  async login(req: LoginRequest): Promise<LoginResponse> {
    return this.http.post('/api/auth/login', req, LoginResponseSchema, {
      unauthenticated: true,
    });
  }

  /** `POST /api/auth/seleccionar-tenant` — sigue sin token (`selectorToken` autoriza). */
  async seleccionarTenant(req: SeleccionarTenantRequest): Promise<SeleccionarTenantResponse> {
    return this.http.post('/api/auth/seleccionar-tenant', req, SeleccionarTenantResponseSchema, {
      unauthenticated: true,
    });
  }

  /** `POST /api/auth/verify-2fa` — sigue sin token (`otpToken` autoriza). */
  async verify2FA(req: Verify2FARequest): Promise<Verify2FAResponse> {
    return this.http.post('/api/auth/verify-2fa', req, Verify2FAResponseSchema, {
      unauthenticated: true,
    });
  }

  /** Limpia el token local. No hay endpoint backend de logout. */
  async logout(): Promise<void> {
    await this.tokenStorage.clear();
  }
}
